import { render, staticRenderFns } from "./StudyNewPageCommon.vue?vue&type=template&id=ffaf81f6&scoped=true"
import script from "./StudyNewPageCommon.vue?vue&type=script&lang=js"
export * from "./StudyNewPageCommon.vue?vue&type=script&lang=js"
import style0 from "./StudyNewPageCommon.vue?vue&type=style&index=0&id=ffaf81f6&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffaf81f6",
  null
  
)

export default component.exports